// EXP: TK-EXP-11-product-page-style-lp
function initializeProductSiblings() {
  const items = document.querySelectorAll('.product-siblings-grid .product-sibling-item');
  const id = document.querySelector('.productSection');
  items.forEach(item => {
    item.removeEventListener('click', handleProductClick);
  });
  
  items.forEach(item => {
    item.addEventListener('click', handleProductClick);
  });
}

function handleProductClick(event) {
  event.preventDefault();
  const id = document.querySelector('.productSection');
  console.log(this.dataset.productHandle);
  console.log(id.dataset.sectionId);
  updateProductSection(this.dataset.productHandle, id.dataset.sectionId);
}

function updateProductSection(productHandle, sectionId) {
  const url = `${window.location.origin}/pages/haven-playmat/${productHandle}?section_id=${sectionId}`;
  fetch(url)
    .then(response => response.text())
    .then(html => {
      const sectionContainer = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (sectionContainer) {
        sectionContainer.innerHTML = html;
        initializeProductSiblings();
      }
    })
    .catch(error => {
      console.error('Error updating section:', error);
    });
}

initializeProductSiblings();